import { TTruckerItem } from 'context/reducers/truckers.type';

type TSortFn = { [key: string]: (x: TTruckerItem, y: TTruckerItem) => number };

export const fnSort: TSortFn = {
  rate: (x, y) => (x.rate > y.rate && -1) || (x.rate < y.rate && 1) || 0,
  distance: (x, y) => {
    const xDistance = x.lastLocation.verified ? x.lastLocation.distance : undefined;
    const yDistance = y.lastLocation.verified ? y.lastLocation.distance : undefined;

    if (xDistance === undefined) return yDistance !== undefined ? 1 : 0;
    if (yDistance === undefined) return -1;

    return xDistance - yDistance;
  },
  dateLastLocation: (x, y) => {
    const xDate = x.lastLocation.date ? new Date(x.lastLocation.date).getTime() : 0;
    const yDate = y.lastLocation.date ? new Date(y.lastLocation.date).getTime() : 0;

    return yDate - xDate;
  },
};
